import { Close } from '@mui/icons-material'
import { Box, IconButton, Skeleton, Stack, useTheme } from '@mui/material'
import { useController } from '../hooks/useController'

export function HeaderLoading() {
  const { close } = useController()

  const theme = useTheme()
  return (
    <Stack
      height={200}
      width="100%"
      bgcolor={theme.palette.background.default}
      paddingX={1.5}
      paddingY={4}
      spacing={3}
    >
      <Stack direction="row" spacing={2} paddingLeft={3} paddingRight={0.5} alignContent="center">
        <Box
          width={42}
          height={42}
          bgcolor="background.default3"
          border="1px solid white"
          borderRadius={1}
        />

        <Stack justifyContent="center" flexGrow={1}>
          <Skeleton width={89} />
          <Skeleton width={138} />
        </Stack>

        <IconButton onClick={close}>
          <Close />
        </IconButton>
      </Stack>
      <Skeleton width="100%" height={30} />
    </Stack>
  )
}
